import { ESRI, GIS, GOOGLE } from '@rsos/maps/constants/reverseGeocodeServices';

/**
 * Get the geocoder service provider display name. Currently used for Gainsight tracking.
 * @param {String} geocoder - Geocoder service provider.
 * @returns String
 */
const getGeocoderName = geocoder => {
  const provider = geocoder?.toLowerCase();

  switch (provider) {
    case ESRI:
      return 'World GIS geocoder';
    case GIS:
      return 'Local GIS geocoder';
    case GOOGLE:
      return 'Google geocoder';
    default:
      return '';
  }
};

export default getGeocoderName;
